<!--时长面板-->
<template>
  <div :class="[isPc ? 'duration-container-pc':'duration-container']">
    <div class="userinfo-p">
      <div class="userinfo-tip">{{content.currentAccount}}：</div>
      <div
        class="userinfo-title"
        v-if="dataInfo.login_status"
      >{{dataInfo.login_info.name}} {{dataInfo.login_info.tel}} {{dataInfo.login_info.hospital_name}}</div>
      <div
        class="userinfo-title"
        v-if="!dataInfo.login_status"
      >{{content.noLogin}}</div>
    </div>
    <div class="padding-p">

      <div class="total-report-p">
        {{viewingType === 'LIVE' ? content.RequiredViewingTimeLIVE:( viewingType === 'VOD' ? content.RequiredViewingTimeVOD:( viewingType === 'ALL' ? content.RequiredViewingTimeALL:content.RequiredViewingTime ) )}}：{{requiredViewingTime}}{{content.Minutes}}
      </div>
      <div class="total-report-progress">
       <div>
         {{content.totalDuration}}：
       </div>
        <div style="margin-top:7px;margin-right: 10px">
          <van-progress class="progress-style" pivot-text="" :color="schedule(actualViewingTime,requiredViewingTime) === 100?'#00ff19':'#0099ff' " stroke-width="8" :percentage="schedule(actualViewingTime,requiredViewingTime)" />
        </div>
        <div style="margin-top:3px;">
          {{Math.trunc(actualViewingTime/60)}}/{{requiredViewingTime}}
        </div>
      </div>
      <!--      为上报时长-->
      <!--      <div class="report-p">-->
      <!--        <div class="not-report">{{content.noReportDuration}}：{{needReportTime | countDown(content)}}</div>-->
      <!--        上报按钮-->
      <!--        <van-button-->
      <!--          class="report-btn"-->
      <!--          color="#FF4800"-->
      <!--          size="small"-->
      <!--          :disabled="needReportTime<=0"-->
      <!--          @click="reportTime"-->
      <!--        >{{content.reportDuration}}</van-button>-->
      <!--      </div>-->
<!--      累计观看时长 -- 时分秒展示样式    -->
<!--      <div class="total-report-p">-->
<!--        {{content.totalDuration}}：{{dataInfo.duration>0?dataInfo.duration:0 | countDown(content)}}-->
<!--      </div>-->
      <div class="report-info-p">
        <div>
          {{content.enterStatus}}：<span :class="[dataInfo.credit_user_status?'reported':'unreport']">{{dataInfo.credit_user_status?content.enterYes:content.enterNo}}</span>
        </div>
        <div class="report-user">
          {{content.applyInfo}}：{{dataInfo.login_info.name}} {{dataInfo.login_info.tel}}
        </div>
        <div
          class="report-user"
          v-if="dataInfo.credit_user_status"
        >{{dataInfo.credit_user_info.name}} {{dataInfo.credit_user_info.tel}} {{dataInfo.credit_user_info.hospital_name}}</div>
      </div>
      <div class="tip-p">
         <div>注：</div>
         <pre class="tip-p-desc">{{durationRemark}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { withData } from '@/utils/dateTimePicker.js'
import { postAddReportedRecord } from '@/models/common'
export default {
  props: {
    dataInfo: {
      type: Object,
      default: function () {
        return {
          login_status: '', // 登录状态true：已登录 false:未登录
          login_info: {
            id: '',
            name: '',
            tel: '',
            hospital_name: ''
          },
          credit_func_status: '', // 学分功能开启状态 true：学分收集功能已开启
          credit_user_status: '', // 学分报名状态true：已报名 false：未报名
          credit_user_info: {
            id: '',
            name: '',
            tel: '',
            hospital_name: ''
          },
          duration: '', // 	时长（秒）
          duration_desc: '' // 时长描述
        }
      }
    },
    liveType: { // 	直播类型LIVE：直播， VOD：点播
      type: String,
      default: ''
    },
    streamId: { // 	直播会议ID
      type: Number,
      default: null
    },
    memberId: { // 用户的ID
      type: String,
      default: ''
    },
    conventionId: { // 会议的ID
      type: Number,
      default: null
    },
    durationRemark: { // 	时长备注
      type: String,
      default: ''
    },
    requiredViewingTime:{ //要求观看时长
      type: Number,
      default: 0
    },
    actualViewingTime:{ //实际观看时长--上报时长
      type: Number,
      default: 0
    },
    viewingType:{ //观看类型
      type: String,
      default: ''
    },
  },
  data() {
    return {
      needReportTime: 0, // 需要上报的时长
      counting: false, // 是否在计时
      // percentage:100,

    }
  },
  filters: {
    //  秒转换成时分秒
    countDown(time, content) {
      let hou = parseInt(time / 3600)
      let min = parseInt(time % (60 * 60 * 24) % 3600 / 60)
      let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60)

      hou = withData(hou)
      min = withData(min)
      sec = withData(sec)

      return `${hou}${content.hh}${min}${content.mm}${sec}${content.ss}`
    },
    //秒转换成分钟
    secondsToMinutes(seconds) {
      return seconds / 60;
    },

  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc']),
  },
  mounted() {
    this.countDownTime();

  },
  methods: {
    //进度条百分比
    schedule(actualViewingTime,requiredViewingTime){
    //  要求观看时长-分钟 --- requiredViewingTime
    //  实际观看时长--上报时长--秒 --- actualViewingTime
    //  当小于 要求观看时长 时返回百分比
    //  当大于等于时返回100
      let actualViewing = Math.trunc(actualViewingTime/60);
      let sum;
      if(actualViewing < requiredViewingTime){
        sum = Math.trunc((actualViewing/requiredViewingTime)*100);
      }else if(actualViewing > requiredViewingTime || actualViewing === requiredViewingTime){
        sum = 100;
      }
      return sum;
    },
    // 上报时间
    reportTime() {
      postAddReportedRecord({
        stream_id: this.streamId,
        member_id: this.memberId,
        type: this.liveType,
        convention_id: this.conventionId,
        duration: this.needReportTime,
      }).then(res => {
        this.$toast(res.data.message)
        this.needReportTime = 0
        this.$emit('reportSuccess')
      })
    },
    // 开始计时
    beginCount() {
      this.counting = true
    },
    // 终止计时
    pauseCount() {
      this.counting = false
    },
    // 自动计时
    countDownTime() {
      if (this.counting) {
        this.needReportTime += 1
      }
      setTimeout(() => {
        this.countDownTime()
      }, 1000)
      this.$forceUpdate()
    }
  },
}
</script>

<style lang="less" scoped>
.duration-container-pc {
  padding: 0.3rem 0.2rem;
  .userinfo-p {
    background-color: #2284E5;
    padding: 0.2rem 0.2rem 0.3rem;
    border-radius: 4px;
    .userinfo-tip {
      font-size: 0.2rem;
      color: #fff;
    }
    .userinfo-title {
      font-size: 0.2rem;
      color: #fff;
      margin-top: 0.2rem;
    }
  }
  .padding-p {
    padding: 0 0.2rem;
    .report-p {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // border-bottom: 1px solid #dadada;
      padding: 0.3rem 0.22rem 0.1rem 0.1rem;
      .not-report {
        color: #ff3600;
        font-size: 0.2rem;
      }
      .report-btn {
        width: 0.97rem;
        height: 0.42rem;
        font-size: 0.2rem;
      }
    }
    .total-report-p {
      // border-bottom: 1px solid #dadada;
      padding: 0.3rem 0.22rem 0.1rem 0.1rem;
      color: #FFF;
      font-size: 0.2rem;
    }
    .total-report-progress{
      padding: 0.3rem 0.22rem 0.1rem 0.1rem;
      //width: 80%;
      color: #FFF;
      font-size: 0.2rem;
      display: flex;
      //justify-content: space-between;
    }
    .progress-style{
      width: 220px;background-color: #fff;
    }
    .report-info-p {
      // border-bottom: 1px solid #dadada;
      padding: 0.3rem 0.22rem 0.1rem 0.1rem;
      color: #FFF;
      font-size: 0.2rem;
      .reported {
        color: #2284E5;
      }
      .unreport {
        color: #b4bbc2;
      }
      .report-user {
        margin-top: 0.38rem;
      }
    }
    .tip-p {
      color: #ffffff;
      padding: 0.3rem 0.22rem 0.1rem 0.1rem;
      font-size: 0.2rem;
      display: flex;
      .tip-p-desc {
        white-space: pre-line;
        line-height: 0.3rem;
        margin: 0;
      }
    }
  }
}
.duration-container {
  padding: 0.15rem 0.1rem;
  .userinfo-p {
    background-color: #2284E5;
    padding: 0.1rem 0.1rem 0.15rem;
    border-radius: 4px;
    .userinfo-tip {
      font-size: 0.16rem;
      color: #fff;
    }
    .userinfo-title {
      font-size: 0.16rem;
      color: #fff;
      margin-top: 0.1rem;
    }
  }
  .padding-p {
    padding: 0 0.1rem;
    .report-p {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dadada;
      padding: 0.19rem 0.11rem 0.19rem 0.05rem;
      .not-report {
        color: #ff3600;
        font-size: 0.16rem;
      }
      .report-btn {
        width: 0.77rem;
        height: 0.32rem;
      }
    }
    .total-report-p {
      border-bottom: 1px solid #dadada;
      padding: 0.19rem 0.11rem 0.19rem 0.05rem;
      color: #131313;
      font-size: 0.16rem;
    }
    .total-report-progress{
      border-bottom: 1px solid #dadada;
      padding: 0.19rem 0.11rem 0.19rem 0.05rem;
      color: #131313;
      font-size: 0.16rem;
      display: flex;
    }
    .progress-style{
      width: 190px;background-color: #e7e6e6;
    }
    .report-info-p {
      border-bottom: 1px solid #dadada;
      padding: 0.19rem 0.11rem 0.19rem 0.05rem;
      color: #131313;
      font-size: 0.16rem;
      .reported {
        color: #2284E5;
      }
      .unreport {
        color: #4a617a;
      }
      .report-user {
        margin-top: 0.19rem;
      }
    }
    .tip-p {
      color: #4a617a;
      padding: 0.19rem 0.11rem 0.19rem 0.05rem;
      font-size: 0.2rem;
      display: flex;
      .tip-p-desc {
        white-space: pre-line;
        line-height: 0.3rem;
        margin: 0;
      }
    }
  }
}
</style>
